"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = exports.StyledEditableFieldWrapper = void 0;
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledEditableFieldWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledIconButton = (0, styled_components_1.default)(IconButton_1.default) `
  padding: 0;
  margin-left: 0.5rem;

  svg {
    transform: translateY(-2px);
    width: 16px;
    height: 16px;
  }
`;
